module.exports = __webpack_public_path__ + "static/media/Medidas_2_4_5_6_7.0ba3c124.pdf";